import { Route, Routes } from "react-router-dom"

const ServidesRoutes = () => {
  return (
    <Routes>
    </Routes>
  )
}

export default ServidesRoutes
